import { Input } from "../ui/input";
import { NAV_CATEGORIES } from "../blocks/navBlocks";
import { BlockRulesEditor } from "../blocks/BlockRulesEditor";

// Which blocks a navigation question allows + optional block budget
export const NavRulesEditor = ({ nav, onChange }) => (
  <div className="space-y-4" data-testid="nav-rules-editor">
    <div>
      <label className="text-sm font-medium">Max blocks allowed <span className="text-muted-foreground font-normal">(optional - loops, ifs and function definitions count as 2)</span></label>
      <Input
        type="number" min={1} placeholder="Unlimited" className="mt-1 w-40"
        value={nav?.max_blocks ?? ""}
        onChange={(e) => onChange({ ...nav, max_blocks: e.target.value === "" ? null : Math.max(1, parseInt(e.target.value, 10) || 1) })}
        data-testid="nav-max-blocks-input"
      />
    </div>
    <BlockRulesEditor
      categories={NAV_CATEGORIES}
      excludedCategories={nav?.excluded_categories || []}
      excludedBlocks={nav?.excluded_blocks || []}
      lockedCategories={["move"]}
      onChange={(rules) => onChange({ ...nav, ...rules })}
      testId="nav-rules"
      hint="Maths, Variables and Functions are newer families - they start hidden on older questions."
    />
  </div>
);
